import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RemoveSpacesPipe } from './remove-spaces.pipe';
import { PhonePipe } from './phone-number.pipe';
import { EnumKeysPipe } from './enum-keys.pipe';
import { EnumStringsPipe } from './enum-strings.pipe';
import { EnumTextValuesPipe } from './enum-keys-text.pipe';
import { CallbackFilterPipe } from './callback-filter.pipe';
import { AddHyphenPipe } from './add-hyphen.pipe';
import { BooleanFilterPipe } from './boolean-filter.pipe';
import { SearchFilterPipe } from './search-filter.pipe';
import { StartCasePipe } from './start-case.pipe';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    RemoveSpacesPipe,
    PhonePipe,
    EnumKeysPipe,
    EnumTextValuesPipe,
    EnumStringsPipe,
    AddHyphenPipe,
    CallbackFilterPipe,
    SearchFilterPipe,
    BooleanFilterPipe,
    StartCasePipe
  ],
  exports: [
    RemoveSpacesPipe,
    PhonePipe,
    EnumKeysPipe,
    EnumTextValuesPipe,
    EnumStringsPipe,
    AddHyphenPipe,
    CallbackFilterPipe,
    SearchFilterPipe,
    BooleanFilterPipe,
    StartCasePipe
  ]
})
export class PipesModule { }



// WEBPACK FOOTER //
// ./client/app/shared/pipes/pipes-module.module.ts